__turbopack_context__.v({
  "verticalDivider": "ReviewSummary-module-scss-module__HnsNEa__verticalDivider",
});
